<template>
    <div>
        <div class="head">
            <div class="my-contact flex-aic">
                <div class="mail item">
                    <div class="icon">
                        <img src="../img/mail.png" alt="">
                    </div>
                    <p>{{ us_mail }}</p>
                </div>
                <div class="phone item">
                    <div class="icon">
                        <img src="../img/phone.png" alt="">
                    </div>
                    <p>{{ us_phone }}</p>
                </div>
            </div>
            <div class="my-head">
                <div class="container flex-aic">
                    <div class="logo">
                        <h2 class="mingzi">{{ company_name }}</h2>
                    </div>
                    <div class="tab flex-aic">
                        <div class="item">
                            <router-link to="/index"
                                style="color:#fff; text-decoration: none;font-size: 20px; transition: all 0.3s;">首页</router-link>
                        </div>
                        <div class="item">
                            <router-link to="/about"
                                style="color:#fff; text-decoration: none;font-size: 20px; transition: all 0.3s">关于我们</router-link>
                        </div>
                        <div class="item">
                            <router-link to="/product"
                                style="color:#fff; text-decoration: none;font-size: 20px; transition: all 0.3s ">产品与服务</router-link>
                        </div>
                        <div class="item">
                            <router-link to="/news"
                                style="color:#fff; text-decoration: none;font-size: 20px; transition: all 0.3s ">新闻中心</router-link>
                        </div>
                        <div class="item">
                            <router-link to="/contact"
                                style="color:#fff; text-decoration: none;font-size: 20px; transition: all 0.3s ">联系我们</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="main">
            <div class="head_bg">
                <img src="../img/contact_us-bg.png" alt="">
                <div class="text" style="top: 10%;">
                    <p style="color: #fff;">新闻和列表</p>
                    <span></span>
                </div>
                <div class="container1" v-for="item in searchList" :key="item.id"
                    @click="contentSearch(item.type, item.id)">
                    <div style="width: 300px;height: 180px;">
                        <img :src="item.img" alt="">
                    </div>
                    <div class="info1">
                        <span class="info2">{{ item.type }}</span>
                        <p style="font-weight: bold;
  color: #000; font-size: 18px;">{{ item.title }}</p>
                    </div>
                    <div>
                        <span style="color: #626060;">{{ item.showTime }}</span>
                    </div>
                </div>
            </div>
        </div>
        <FootCommon></FootCommon>
    </div>
</template>
<script>
import FootCommon from '@/components/FootCommon.vue';
import { getSearch } from "@/api/HeadSearch";
import { addressList } from "@/api/index";
import { getnewsinfoList } from "@/api/news";
import { getIndustryListInfo } from "@/api/product";
export default {
    name: 'searchResults',
    components: {
        FootCommon
    },
    data() {
        return {
            us_phone: '',
            us_mail: '',
            company_name: '',
            searchList: [],
        }
    },
    created() {
        this.addressList()
        this.getSearch()
    },
    methods: {
        async addressList() {
            const { data } = await addressList()
            console.log(data, 456666);
            this.company_name = data.company_name
            this.us_phone = data.us_phone
            this.us_mail = data.us_mail
        },
        async getSearch() {
            const searchQuery = this.$route.params.query;
            console.log(searchQuery, 25896);
            const { data } = await getSearch(searchQuery)
            console.log(data);
            this.searchList = data
        },
        async contentSearch(type, id) {
            console.log(type, id, 6666);
            if (type === '新闻动态') {
                const res = await getnewsinfoList(id)
                console.log(id, "搜索");
                console.log(res);
                this.$router.push({ name: 'NewsInfo', params: { id } });
            }
            else if (type !== '新闻动态') {
                const res = await getIndustryListInfo(id)
                console.log(res, 15698);
                this.$router.push({ name: 'ListDetails', params: { id } });
            }
        }
    }
}
</script>
<style>
@import '../style/common.css';
@import '../style/basic.css'
</style>